import repository from '../../repositories/crm/crm.pipeline.repository';

const findBySellerId = (sellerId) =>
    repository
        .findBySellerId(sellerId)
        .then(res => res.data || []);

const findAll = () =>
    repository
        .findAll()
        .then(res => res.data || []);

export default {
    findBySellerId,
    findAll
}